import React, { useRef, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';

import { cardsActions, useStore } from '@modules';
import { Redirect3DSResponse } from '@modules/cards/types';

import LoaderLayout from '@layouts/LoaderLayout';

import style from './Card3DSFlow.scss';

const cn = bemCssModules(style, 'Card3DSFlow');

export type TCard3DSFlow = {
  onSuccess: () => void;
  onFrameLoaded: (status: boolean) => void;
  redirect?: Redirect3DSResponse;
};

export const Card3DSFlow: CustomFC<TCard3DSFlow> = props => {
  const { className, onSuccess, onFrameLoaded } = props;

  const iframe = useRef<HTMLIFrameElement>(null);
  const { t } = useTranslation();
  const [iframeIsLoaded, setIframeIsLoaded] = useState(false);
  const [{ cards }, dispatch] = useStore();

  /* eslint-disable react/destructuring-assignment */
  const { passed, redirect = props.redirect } = cards.card3DS;

  useEffect(() => {
    if (passed && onSuccess) onSuccess();
  }, [passed]);

  useEffect(() => {
    onFrameLoaded(iframeIsLoaded);
  }, [iframeIsLoaded]);

  useEffect(() => {
    const listener = (event: MessageEvent) => {
      if (event.data.type === CONST.event3dsPassed && event.origin === CONST.card3dsDomain) {
        dispatch(cardsActions.set3DSPassed(true));
      }
    };
    window.addEventListener('message', listener);
    return () => window.removeEventListener('message', listener);
  }, []);

  const onLoadIframe = () => {
    if (redirect && !iframeIsLoaded) {
      iframe.current?.contentWindow?.postMessage(
        { type: CONST.event3dsStarted, data: redirect },
        CONST.card3dsDomain
      );
      dispatch(cardsActions.clearRedirect());
      setIframeIsLoaded(true);
    }
  };

  return (
    <div className={cn(null, [className])}>
      <LoaderLayout isLoading={!!passed}>
        <iframe
          className={cn('iframe')}
          title={t('card.3ds_flow')}
          ref={iframe}
          src={CONST.card3dsDomain}
          width="100%"
          height="100%"
          frameBorder="0"
          onLoad={onLoadIframe}
        />
      </LoaderLayout>
    </div>
  );
};

export default Card3DSFlow;
